import { AppMenuItems } from "../../infrastructure/enum/Common";
import {
  getParentOrigin,
  isEmbeddedInIframe,
} from "../../infrastructure/parentTokenRelay";
import { routes } from "../../router";
import { IcPages, Pages } from "./useIframe.constants";
import { IframeMessage } from "./useIframe.model";

/**
 * Host interface used when the IMAS ClientApp is embedded as an <iframe> inside
 * the Phantom Layout (see useIframe.constants for the message types).
 *
 * - isIframe: true when this app is running inside the Layout's iframe.
 * - messageToIframe: posts a message to the parent (Layout) window, restricted
 *   to the parent's origin.
 * - navigateTo: maps a page name sent by the Layout (a sidenav item or an
 *   IcPages entry) to the matching IMAS route, so the iframe shows that screen.
 *
 * The Layout owns the sidenav, so every menu item it can open needs a case in
 * navigateTo. A page with no case is silently ignored and the iframe stays put.
 */
const useIframe = () => {
  const isIframe = isEmbeddedInIframe();

  const messageToIframe = (message: IframeMessage) => {
    window.parent.postMessage(message, getParentOrigin());
  };

  // Names must match MenuItems in the Layout's NavigationDrawer.constants.tsx.
  const navigateTo = (page?: Pages) => {
    switch (page) {
      case AppMenuItems.Home:
        routes.home.push();
        return;
      case AppMenuItems.Agents:
        routes.agentSearch.push();
        return;
      case AppMenuItems.contractManagement:
        routes.contractmanagement.push();
        return;
      case AppMenuItems.agentManagement:
        routes.agentmanagement.push();
        return;
      case AppMenuItems.production:
        routes.bookOfBusiness.push();
        return;
      case AppMenuItems.universalUpload:
        routes.universalUpload.push();
        return;
      case AppMenuItems.rtsReview:
        routes.rtsReview.push();
        return;
      case AppMenuItems.readinessReview:
        routes.readinessReview.push();
        return;
      case AppMenuItems.Insured:
        routes.customerSearch.push();
        return;
      case AppMenuItems.Tasks:
        routes.tasks.push();
        return;
      case AppMenuItems.Documents:
        routes.documents.push();
        return;
      case AppMenuItems.Workflow:
        routes.docWorkflow.push();
        return;
      case AppMenuItems.Goals:
        routes.goals.push();
        return;
      case AppMenuItems.Leads:
        routes.leads.push();
        return;
      case AppMenuItems.Outreach:
        routes.marketers.push();
        return;
      case AppMenuItems.Supplies:
        routes.supplies.push();
        return;
      case AppMenuItems.carrierManagement:
        routes.carrierManagement.push();
        return;
      case AppMenuItems.Administration:
        routes.administration.push();
        return;
      case AppMenuItems.enhancedReports:
        routes.enhancedReports.push();
        return;
      case AppMenuItems.Dialer:
        routes.autoDialer.push();
        return;
      case AppMenuItems.UITemplate:
        routes.demotest.push();
        return;
      case IcPages.LOGOUT:
        routes.logout.push();
        return;
      case IcPages.NEED_HELP:
        routes.needhelp.push();
        return;
      case IcPages.TERMS_OF_USE:
        routes.termsofuse.push();
        return;
    }
  }

  return {
    isIframe,
    navigateTo,
    messageToIframe,
  };
};

export { useIframe };
